import cookies from "js-cookie";
export const PAGE_REVIEW_DETAIL = "reviewDetail.html";
export const PAGE_REVIEW = "review.html";
export const PAGE_HOME = "index.html";
export const PAGE_REGISTER = "register.html";
export const PAGE_DETAILS = "details.html";
export const PAGE_REGISTRATION_ENDS = "registerEnd.html";
export const PAGE_PERSONAL = "personal.html";
export const REGISTER = "Register";
export const RUN_NOW = "Run Now";
export const ENROLLMENT_IS_FULL = "Enrollment is full";
export const REGISTRATION_IS_CLOSED = "REGISTRATION_IS_CLOSED";

export const isLogin = cookies.get("cUserId");

export const sites = "(global|vn|my|ph|th|sg|id|pl|kz-ru|kz|mx|co|pe|cl|pk|kh)";

export const COUNTRY_CONFIG = {
  global: {
    lang: "en",
  },
  vn: {
    siteCode: "vn",
    lang: "vi",
  },
  my: {
    siteCode: "my",
    lang: "en",
  },
  ph: {
    siteCode: "ph",
    lang: "en",
  },
  th: {
    siteCode: "th",
    lang: "th",
  },
  sg: {
    siteCode: "sg",
    lang: "en",
  },
  id: {
    siteCode: "id",
    lang: "id",
  },
  pl: {
    siteCode: "pl",
    lang: "pl",
  },
  "kz-ru": {
    siteCode: "ru",
    lang: "ru",
  },
  kz: {
    lang: "en",
  },
  mx: {
    siteCode: "mx",
    lang: "es",
  },
  co: {
    lang: "en",
  },
  pe: {
    lang: "en",
  },
  cl: {
    siteCode: "cl",
    lang: "es",
  },
  pk: {
    siteCode: "pk",
    lang: "en",
  },
};
const appLocal = window.location.pathname.split("/")[2] || "global";

const needGdprArea_EEA_UK_Turkey_Global = [
  "global",
  "es",
  "fr",
  "it",
  "de",
  "uk",
  "tr",
  "pl",
];
const needGdprArea_Others = [
  "id",
  "ru",
  "ua",
  "my",
  "vn",
  "th",
  "bd",
  "eg",
  "ph",
  "pk",
  "mx",
  "cl",
  "br",
  "ng",
  "kz",
  "cz",
  "ro",
];
const needGdprArea = [
  ...needGdprArea_EEA_UK_Turkey_Global,
  ...needGdprArea_Others,
];
export const IS_CONSENT_ANALYSIS_COOKIE = (() => {
  return needGdprArea.includes(appLocal);
})();
export const intoCookieBanner = () => {
  const CURRENT_COUNTRY_CONFIG = COUNTRY_CONFIG[appLocal] || {};
  const siteCode = CURRENT_COUNTRY_CONFIG.siteCode || "";
  const country = !!siteCode ? "&country=" + siteCode : "";
  const language = CURRENT_COUNTRY_CONFIG.lang || "en";
  if (IS_CONSENT_ANALYSIS_COOKIE) {
    let consentScriptM = document.createElement("script");
    consentScriptM.type = "text/javascript";
    consentScriptM.async = true;
    consentScriptM.src =
      "//consent.trustarc.com/notice?domain=xiaomi.com&c=teconsent&js=nj&noticeType=bb&text=true&gtm=1" +
      country +
      "&language=" +
      language;
    document.getElementById("teconsent").appendChild(consentScriptM);
    consentScriptM.onload = () => {
      // 创建关闭按钮元素
      const closeButton = document.createElement("div");
      closeButton.className = "close-button";
      closeButton.innerHTML = "&times;";
      const timer = setInterval(() => {
        const trusteConsentTrack = document.getElementById(
          "truste-consent-track"
        );
        if (trusteConsentTrack) {
          // 添加关闭按钮点击事件
          closeButton.addEventListener("click", () => {
            trusteConsentTrack.style.display = "none";
          });
          // 将关闭按钮添加到 truste-consent-track 标签内
          trusteConsentTrack.appendChild(closeButton);
          clearInterval(timer);
        }
      }, 500);
    };
  }
  let script3 = document.createElement("script");
  script3.type = "text/javascript";
  script3.src =
    "//alsgp0.fds.api.xiaomi.com/micom-independent-static/poprun/cookie-clear.js";
  document.getElementById("cookie-clear").appendChild(script3);
};
